var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckboxInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 71596",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 17.5H3.6c-1.71 0-3.1-1.39-3.1-3.1V3.6C.5 1.89 1.89.5 3.6.5h10.8c1.71 0 3.1 1.39 3.1 3.1v10.8c0 1.71-1.39 3.1-3.1 3.1z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 1A2.603 2.603 0 0 0 1 3.6v10.8C1 15.834 2.166 17 3.6 17h10.8c1.434 0 2.6-1.166 2.6-2.6V3.6C17 2.166 15.834 1 14.4 1H3.6m0-1h10.8A3.6 3.6 0 0 1 18 3.6v10.8a3.6 3.6 0 0 1-3.6 3.6H3.6A3.6 3.6 0 0 1 0 14.4V3.6A3.6 3.6 0 0 1 3.6 0z",
    style: {
      fill: "#d8dde3",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13941",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72361",
    d: "M56.013 68.275a.938.938 0 0 1 0 1.326l-5.85 5.85a.938.938 0 0 1-1.326 0l-3.562-3.563a.938.938 0 0 1 1.325-1.326l2.9 2.9 5.187-5.187a.938.938 0 0 1 1.326 0z",
    transform: "translate(-41.625 -62.9)",
    style: {
      fill: "#d8dde3",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxInactive);
export default __webpack_public_path__ + "static/media/ic_checkbox_inactive.e455e23f9d5b60d5bf1c5ca4d5d8ade0.svg";
export { ForwardRef as ReactComponent };